export const messages = {
  en: {
    registerProtocol: {
      title: 'Registration Agreement',
      userProtocol: 'User Agreement',
      merchantProtocol: 'Merchant Agreement',
      editorPlaceholder: 'Required, please fill in the content',
      fetchError: 'Failed to fetch registration agreement'
    }
  },
  zh: {
    registerProtocol: {
      title: '注册协议',
      userProtocol: '用户协议',
      merchantProtocol: '商家协议',
      editorPlaceholder: '必填，请填写内容',
fetchError: '获取注册协议失败'
    }
  },
  'zh-TW': {
    registerProtocol: {
      title: '註冊協議',
      userProtocol: '用戶協議',
      merchantProtocol: '商家協議',
      editorPlaceholder: '必填，請填寫內容',
      fetchError: '獲取註冊協議失敗'
    }
  }
}